module.exports = __webpack_public_path__ + "img/172290.043128fe.png";